import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEO Meta component to handle dynamic page titles and meta tags.
 */
const Meta = ({ 
  title, 
  description = "Grand Palace General Trading — Your trusted partner for quality building materials, sanitaryware, and electrical supplies in UAE.",
  image = "https://gpgt.ae/logo192.png",
  url = "https://gpgt.ae",
  type = "website",
  keywords = "building materials, sanitaryware, electrical supplies, hardware, tools, safety gear, Dubai, UAE, wholesale",
  structuredData = null
}) => {
  const siteTitle = "Grand Palace General Trading";
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;

  return (
    <Helmet>
      {/* Standard Metadata */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Schema.org Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default Meta;
